import { OptimizationGroupsPage } from '@/pages/optimization-groups'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/p/og/')({
	component: OptimizationGroupsPage,
})
